/**
 * Lazy Sentry capture helper.
 *
 * Keeps the Sentry SDK out of the critical initial bundle: the SDK is only
 * pulled in (as a separate async chunk) at the moment an error actually needs
 * to be reported. A failure to load or initialise Sentry must never break the
 * caller — every path is swallowed and logged as a warning.
 */
export function reportError(error: unknown, extra?: Record<string, unknown>): void {
  void (async () => {
    try {
      const { Sentry } = await import('./sentry');
      Sentry?.captureException(error, extra ? { extra } : undefined);
    } catch (err) {
      console.warn('[Sentry] Deferred capture failed:', err);
    }
  })();
}
